export default __webpack_public_path__ + "static/media/Next.b65f7765.svg";